import MockAdapter from 'axios-mock-adapter'
import shippingMethodsData from './../../mocks/shippingMethods.json'
import shippingMethodsDataAu from './../../mocks/shippingMethodsAU.json'
import shippingMethodsDataBr from './../../mocks/shippingMethodsBR.json'
import variantsMock from './../../mocks/wcs-pdp-color-variants.json'
import axios from 'axios'

const mock = new MockAdapter(axios, { delayResponse: 2000 })

mock.onGet('/api/shipping-methods').reply((config) => {
  const { countryCode } = config.params
  const orderShippingMode = localStorage.getItem('orderShippingMode')
  let shippingMethodsDataSource = null
  switch (countryCode) {
    case 'US':
      shippingMethodsDataSource = shippingMethodsData
      break
    case 'AU':
      shippingMethodsDataSource = shippingMethodsDataAu
      break
    case 'BR':
      shippingMethodsDataSource = shippingMethodsDataBr
      break
    default:
      console.error('Country not supported')
  }
  const preselectedId = shippingMethodsDataSource?.shippingMethods?.find(method => (method.code === orderShippingMode || method.name === orderShippingMode || method.title === orderShippingMode))?.id || null
  const modifiedData = { ...shippingMethodsDataSource}
  if(preselectedId) {
    modifiedData.selectedShippingId = preselectedId
  }
  if (['US','AU','BR'].includes(countryCode)) {
    return [200, {
      data:modifiedData,
    }]
  } else {
    return [404, { error: 'Country not supported' }]
  }
})

mock
  .onGet(/\/mock\/wcs\/resources\/store\/\d+\/products\/\d+\/variants/)
  .reply(config => {
    const url = config.url || ''

    const match = url.match(
      /store\/(\d+)\/products\/(\d+)\/variants/
    )

    const storeId = match?.[1]
    const productId = match?.[2]

    const params = new URLSearchParams(
      url.split('?')[1]
    )
    return [
      200,
      {
        variants: variantsMock,
        debug: {
          storeId,
          productId,
          langId: params.get('langId'),
        },
      },
    ]
  })


mock.onAny().passThrough()


export const fetchMockShippingMethods = async ({
  countryCode,
}:{
  countryCode: string,
  storeId?:string
}) => {
  try {
    const response = await axios.get('/api/shipping-methods',{ params: { countryCode }})
    return response.data
  } catch (error) {
    console.error('error while fetching mocked shipping methods:', error)
    throw error
  }
}

export const fetchMockColorVariants = async ({
  url,
}: {
  url: string
}) => {
  try {
    const response = await axios.get(
      url,
    )
    return response.data
  } catch (error) {
    console.error('error while fetching mocked color variants:', error)
    throw error
  }
}
